angular.module('akimboApp.config', [])

.constant('baseURI', 'https://app.akimbocard.com/api/v2/')

.constant('SOCURE_DEVICE_PUBLIC_KEY', '8830c0e0-d3c6-401a-a7bd-652499fb1169')

.constant('DEFAULT_BRAND', 'akimbo')

.constant('ENV', 'production')

.constant('ROLLBAR_OFF', 0)

;